// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__RiiHN","l20-1":"styles_l20-1__sNliS","l20-2":"styles_l20-2__LKco7"};